import {useGetTeamProgressTiles} from "@/app2/shared/data";
import {useTeamProgressContext} from "../context/TeamProgressContext";
import {useEffect} from "react";

/**
 * Feature hook for Team Progress KPI tiles
 * 
 * Fetches the 6 KPI metrics and manages section loading state.
 */
export function useTiles() {
	const {filters, updateSectionState} = useTeamProgressContext();

	const {data, isLoading, isError, error} = useGetTeamProgressTiles({
		dateFrom: filters.dateFrom,
		dateTo: filters.dateTo,
		archivedUsers: filters.archivedUsers
	});

	// Update section loading state
	useEffect(() => {
		updateSectionState(isLoading, "widgets");
	}, [isLoading, updateSectionState]);

	return {
		tiles: data,
		isLoading,
		isError,
		error
	};
}
